import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Col, Row } from 'antd';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import { ProductRegistration } from '@app/components/apps/ProductRegistration/ProductRegistration';

export const EditPRIFSPage: React.FC = () => {
  const location = useLocation();
  const { id } = location.state || {};
  const { t } = useTranslation();
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('Edit Product Registration');

  const { setBreadcrumb, clearHeaderButtons } = useHeader();

  const routes = [
    {
      path: '/product-registrations-imp-free-sales',
      breadcrumbName: 'PR - Importer Free Sales',
    },
    {
      path: '/edit-product-registrations-imp-free-sales',
      breadcrumbName: currentBreadcrumName,
    },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(currentBreadcrumName);
      clearHeaderButtons();
    };
  }, [setBreadcrumb, clearHeaderButtons, currentBreadcrumName]);
  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <ProductRegistration
            type={'edit'}
            editable={true}
            id={id}
            pageTitle={`Edit Product Registration`}
            setCurrentBreadcrumName={setCurrentBreadcrumName}
          />
        </Col>
      </Row>
    </>
  );
};

export default EditPRIFSPage;
